import React from 'react';
import { Divider, Typography } from '@mui/material';
import chulaDal from '../../../../../images/Agri-info/crops/Chhola dal_ছোলা.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const ChulaDalInfo = () => {

    // dynamic title
    useDocumentTitle("ছোলা");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h3"
                noWrap
                component="div"
            >
                ছোলা
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={chulaDal} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p><b>পুষ্টি মূল্য : </b>ছোলাতে প্রচুর পরিমানে খাদ্য শক্তি ও প্রোটিন আছে।</p>
                            <p className="card-text fw-bold">ব্যবহার : </p>
                            <p className="card-text">ডাল হিসেবে এবং পবিত্র রমজান মাস সহ অন্যান্য সময়ে মুখরোচক খাদ্য হিসেবে।</p>

                            <p className="card-text fw-bold">উপযুক্ত জমি ও মাটি :</p>
                            <p className="card-text">দো-আঁশ ও এটেল দো-আঁশ মাটিতে ছোলা ভালো জন্মে।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>

                <p className="card-text fw-bold">জাত পরিচিতি :</p>
                <p className="card-text">
                    <b>বারি ছোলা-২ (বড়াল)</b><br />
                    গাছের রং সবুজ। বীজ স্থানীয় জাতের চেয়ে বড়। হাজার বীজের ওজন ১৪০-১৫০ গ্রাম। বীজের রং হালকা বাদামি। বীজের আকার বড় হওয়ায় এ জাতের ছোলা কৃষক ও ক্রেতার কাছে অধিক গ্রহণযোগ্য। ডাল রান্না হওয়ার সময়কাল ৩০-৩৫ মিনিট। আমিষের পরিমাণ ২৩-২৭%। বারি ছোলা-২ এর জীবনকাল ১২০-১৩০ দিন। হেক্টরপ্রতি ফলন ১.৩-১.৬ টন। এ জাত নুয়ে পড়া বা উইল্ট রোগ প্রতিরোধ ক্ষমতা সম্পন্ন।</p>
                <p><b>বারি ছোলা-৩ (বরেন্দ্র)</b><br />
                    এ জাতের গাছ খাড়া প্রকৃতির। রং হালকা সবুজ, পত্রফলক বেশ বড় এবং ডগা সতেজ। বীজের আকার বেশ বড়। হাজার বীজের ওজন ১৮৫-১৯৫ গ্রাম। ডাল রান্না হওয়ার সময়কাল ৪০-৪৪ মিনিট। আমিষের পরিমাণ ২৩-২৬%। সঠিক সময়ে বুনলে পাকতে সময় লাগে ১১৫-১২৫ দিন। এ জাতটি রাজশাহীর বরেন্দ্র অঞ্চলে আবাদের জন্য বেশি উপযোগী। ফলন হেক্টরপ্রতি ১.৮-২.০ টন পাওয়া যায়।</p>
                <p><b>বারি ছোলা-৪ (জোড়াফুল)</b><br />
                    গাছ মাঝারি খাড়া এবং পাতা গাঢ় সবুজ। কান্ডে খয়েরি রংয়ের ছাপ দেখা যায়। বীজের পার্শ্ব দিক সামান্য চেপ্টা, ত্বক মসৃণ। বীজের রং হালকা বাদামি। হাজার বীজের ওজন ১৩২-১৩৮ গ্রাম। গাছের উচ্চতা ৫০-৬০ সেমি। ডাল রান্না হওয়ার সময়কাল ৩২-৩৮ মিনিট। আমিষের পরিমাণ ১৮-২১%। জীবনকাল ১২০-১২৫ দিন। ফলন হেক্টরপ্রতি ১.৯-২.০ টন। এ জাতটি ফিউজেরিয়াম উইল্ট রোগ প্রতিরোধ ক্ষমতা সম্পন্ন।</p>
                <p><b>বারি ছোলা-৫ (পাবনাই)</b><br />
                    বীজ আকারে ছোট, রং ধূসর বাদামি এবং হিলাম খুব স্পষ্ট। বীজের পার্শ্ব কিছুটা চেপ্টা এবং ত্বক মসৃণ। হাজার বীজের ওজন ১১০-১২০ গ্রাম। ডাল রান্না হওয়ার সময়কাল ৩৫-৪০ মিনিট। আমিষের পরিমাণ ২০-২২%। এ জাত ১২৫-১৩০ দিনে পাকে। ফলন হেক্টরপ্রতি ১.৮-২.০ টন।</p>
                <p><b>বারি ছোলা-৬ (নাভারুন)</b><br />
                    বীজের আকার কিছুটা গোলাকৃতি, ত্বক মসৃণ এবং রং উজ্জ্বল বাদামি হলদে। বীজ আকারে দেশী জাতের চেয়ে বড়। হাজার বীজের ওজন ১৫৫-১৬৫ গ্রাম। এ জাতের ডাল রান্নার সময়কাল ৩২-৩৭ মিনিট। আমিষের পরিমাণ ১৯-২১%। জীবনকাল ১২৫-১৩০ দিন। ফলন হেক্টরপ্রতি ১.৮-২.০ টন। জাতটি নাবীতে বপন করেও অন্যান্য জাতের চেয়ে অধিক ফলন পাওয়া যায়।</p>
                <p><b>বীজ বপন :</b><br />
                    ছিটিয়ে ও লাইন করে বীজ বপন করা যায়। লাইনে বপনের ক্ষেত্রে লাইন থেকে লাইনের দূরত্ব ৪০ সেমি রাখতে হবে। বীজের হার ৪৫-৫০ কেজি/হেক্টর, ছিটিয়ে বপনের ক্ষেত্রে বীজের পরিমাণ কিছু বেশি অর্থাৎ ৫০-৬০ কেজি/হেক্টর দিতে হবে। অগ্রহায়ণ মাসের ৫ থেকে ২৫ (২০ নভেম্বর-১০ ডিসেম্বর)। তবে বরেন্দ্র অঞ্চলের জন্য কার্তিক মাসের দ্বিতীয় সপ্তাহ থেকে তৃতীয় সপ্তাহ (অক্টোবর শেষ সপ্তাহ থেকে নভেম্বরের প্রথম সপ্তাহ) সময়ে বীজ বপন করতে হবে।</p>
                <p><b>শেষ</b><br />
                    চাষের সময় সমুদয় সার প্রয়োগ করতে হয়। অপ্রচলিত এলাকায় আবাদের জন্য সুপারিশ মত নির্দিষ্ট অণুজীব সার প্রয়োগ করা যেতে পারে। প্রতি কেজি বীজের জন্য ৮০ গ্রাম হারে অণুজীব সার প্রয়োগ করতে হয়। ইনোকুলাম সার ব্যবহার করলে ইউরিয়া সার প্রয়োগ করতে হয় না।</p>
                <p><b>সেচ ও আগাছা ব্যবষপনা :</b><br />
                    বপনের ৩০-৩৫ দিনের মধ্যে একবার আগাছা দমন করা প্রয়োজন। অতি বৃষ্টির ফলে যাতে জলাবদ্ধতার সৃষ্টি না হয় সেজন্য অতিরিক্ত পানি বের করে দেওয়ার ব্যবস্থা রাখতে হবে। জমিতে পর্যাপ্ত রস না থাকলে বপনের পর হালকা সেচ দিতে হবে।</p>
                <p><b>পোকামাকড় ব্যবস্থাপনা :</b></p>
                <p><b>পোকার নাম : পড বোরার</b></p>
                <p><b>ক্ষতির নমুনা : </b><br />
                    পোকার কীড়া (শুককীট) কটি পাতা, ফুল ও ডগা খায়। ফল বড় হওয়ার সময় ছিদ্র করে ভিতরের নরম অংশ খায়। একটি কীড়া পূর্ণাঙ্গ হওয়ার পূর্বে ৩০-৪০ টি ফল খেয়ে ফেলতে পারে। এ রোগে ছোলার উৎপাদন অনেক হ্রাস পায়।</p>
                <p><b>ব্যবস্থাপনা :  </b><br />
                    কীড়া ছোট অবস্থায় দাত দিয়ে সংগ্রহ করে মেরে ফেলতে হবে। আক্রমণ বেশি হলে ডেসিস ২.৫ ইসি বা রিপকর্ড ১০ ইসি বা সিমবুস ১০ ইসি বা ফেসম ১০ ইসি ১ মিলি প্রতি লিটার পানিতে মিশিয়ে ১৫ দিন পরপর ১-২ বার সেপ্র করতে হবে।</p>
                <br />
                <p><b>রোগ ব্যবস্থাপনা :</b></p>
                <p><b>রোগের নাম : ছোলার উইল্ট বা নুইয়ে পড়া রোগ</b></p>

                <p><b>ক্ষতির নমুনা :</b><br />
                    চারা অবস্থায় এ রোগে আক্রান্ত গাছ মারা যায় এবং পাতায় রংয়ের কোন পরিবর্তন হয় না। পরিপূর্ণ বয়সে গাছ আক্রান্ত হলে পাতা ক্রমান্বয়ে হলদে রং ধারণ করে। আক্রান্ত গাছ ঢলে পড়ে ও শুকিয়ে যায়। লম্বালম্বিভাবে কাটলে কান্ডের মাঝখানের অংশ কালো দেখা যায়।</p>
                <p><b>ব্যবস্থাপনা : রোগ প্রতিরোধী</b><br />
                    জাত যেমন বারি ছোলা- এবং বারি ছোলা-৪ এর চাষ করতে হবে। ফসলের পরিত্যক্ত অংশ পুড়িয়ে ফেলতে হবে। পর্যাপ্ত পরিমাণে জৈব সার ব্যবহার করতে হবে।</p>
                <br />
                <p><b>রোগের নাম : ছোলার গোড়া পচা রোগ</b></p>
                <p><b>ক্ষতির নমুনা : </b><br />
                    চারা গাছে এ রোগ বেশি দেখা যায়। আক্রান্ত গাছ হলদে হয়ে যায় এবং শিকড় ও কান্ডের সংযোগ স্থলে কালো দাগ পড়ে। গাছ টান দিলে সহজেই উঠে আসে। আক্রান্ত স্থানে গাছের গোড়ায় ছত্রাকের জালিকা ও সরিষার দানার মত স্কেলেরোসিয়া গুটি দেখা যায়।</p>
                <p><b>ব্যবস্থাপনা : </b><br />
                    ফসলের পরিত্যক্ত অংশ পুড়িয়ে ফেলতে হবে। সুষম হারে সার প্রয়োগ করতে হবে। ভিটাভেক্স-২০০ প্রতি কেজি বীজের জন্য ২.৫-৩.০ গ্রাম হারে মিশিয়ে বীজ শোধন করতে হবে।</p>
                <br />
                <p><b>রোগের নাম: ছোলার বট্রাইটিস গ্রে মোল্ড রোগ</b></p>
                <p><b>ক্ষতির নমুনা : </b><br />
                    ছোলার বৃদ্ধি ব্যবস্থাপনা কিংবা ফল আসার শুরুতেই এর রোগের আক্রমণ লক্ষ করা যায়। এ রোগের লক্ষণ কান্ড, পাতা, ফুল ও ফলে প্রকাশ পায়। আক্রান্ত স্থানে ধূসর রংয়ের ছত্রাকের উপস্থিতি দেখা যায়।</p>
                <p><b>অনুকুল পরিবেশ : </b><br />
                    জমিতে গাছ বেশি ঘন থাকলে এবং বাতাসের আর্দ্রতা বেশি থাকলে এ রোগ ব্যাপকতা লাভ করে।</p>
                <p><b>ব্যবস্থাপনা : </b><br />
                    ফসলের পরিত্যক্ত অংশ পুড়িয়ে ফেলতে হবে। বাভিস্টিন অথবা থিরাম প্রতি কেজি বীজে ২.৫-৩.০ গ্রাম হারে মিশিয়ে বীজ শোধন করতে হবে। বাভিস্টিন ০.২% হারে ১০-১২ দিন পরপর ২-৩ বার সেপ্র করতে হবে।</p>
                <br />
                <p><b>গুদামজাত ডালের পোকা ব্যবস্থাপনা</b></p>
                <p><b>ভূমিকা : </b><br />
                    পূর্ণবয়স্ক পোকা ও কীড়া উভয়ই গুদামজাত ডালের ক্ষতি করে থাকে।</p>
                <p><b>অক্ষতির নমুনা : </b><br />
                    এ পোকা ডালের খোসা ছিদ্র করে ভিতরে ঢুকে শাঁস খেতে থাকে। ফলে দানা হাল্কা হয়ে যায়। এর ফলে বীজের অঙ্কুরোদগম ক্ষমতা নষ্ট হয়ে যায় এবং খাওয়ার অনুপযুক্ত হয়ে পড়ে।</p>
                <p><b>ব্যবস্থাপনা : </b><br />
                    গুদামজাত করার আগে দানা ভালভাবে পরিষ্কার করতে হয়। ডালের দানা শুকিয়ে পানির পরিমান ১২% এর নিচে আনতে হবে। বীজের জন্য টন প্রতি ৩০০ গ্রাম ম্যালাথিয়ন বা সেভিন ১০% গুড়া মিশিয়ে পোকার আক্রমণ প্রতিরোদ করা যায়। ফসটক্সিন ট্যাবলেট ২টি বড়ি প্রতি ১০০ কেজি গুদামজাত ডালে ব্যবহার করতে হয়। এ বড়ি আবদ্ধ পরিবেশে ব্রবহার করতে হয়।</p>
                <br />
                <p><b>ফসল তোলা : </b>চৈত্রের প্রথম সপ্তাহ থেকে মধ্য-চৈত্র (মধ্য-মার্চের শেষ) সময়ে ফসল সংগ্রহ করতে হবে।</p>

            </div >
        </div >


    );
};

export default ChulaDalInfo;